module.exports = __webpack_public_path__ + "static/media/dr-douse.c18746c9.jpg";